import React from 'react';
import Avatar from '@material-ui/core/Avatar'
import {connect} from 'react-redux'
import Menu from '@material-ui/core/Menu';import MenuItem from '@material-ui/core/MenuItem';
import {userSignOut} from 'actions/Auth';
import IntlMessages from 'util/IntlMessages';
import createHistory from 'history/createHashHistory';
import axios from 'axios';
import {BASE_URL_OSLOG, BASE_URL_API2, HOSTNAME_OSLOG} from 'constants/ActionTypes';

const history = createHistory();

class UserInfo extends React.Component {

    state = {
        anchorEl: null,
        open: false,
    };

    handleClick = event => {
        this.setState({open: true, anchorEl: event.currentTarget});
    };

    handleRequestClose = (param) => {

        if(param === 'setting'){
            history.push('/app/config');
        } else if (param === 'profile') {
            history.push('/app/profile');
        } else {

        }
        this.setState({open: false});
    };

    handleLogout = async () => {
        const URL = `${BASE_URL_OSLOG}/app/logout`;
        // console.log(URL)
        
        await axios({
            headers: {
                'Accept': 'application/json',
            },
            method: 'get',
            url: URL,
            withCredentials: true,
        }).then((response) => response).catch((error) => error.response);
        localStorage.removeItem('user_id');
        localStorage.removeItem('apiKey');
        localStorage.removeItem('rolename');
        localStorage.removeItem('name');
        localStorage.removeItem('menu_user');
        localStorage.removeItem('companyId');
        
        // window.location = window.location.origin;
        if(window.location.hostname === HOSTNAME_OSLOG){
            window.location = BASE_URL_OSLOG+"/v5/";
        } else {
            window.location = window.location.origin;
        }
        
        // if(window.location.hostname === HOSTNAME_OSLOG){
        //     window.location = BASE_URL_OSLOG+"/v5/";
        // } else if (window.location.hostname === '202.47.70.196'){
        //     window.location = `${BASE_UR_API2}/epoool`;
        // } else if(window.location.hostname === 'linstasarta.oslog.id'){
        //     window.location = "http://linstasarta.oslog.id/";
        // } else {
        //     window.location = "http://localhost:4000";
        // }
        
    }

    handleClickImage = () => {
        history.push('/');
    }

    render() {
        const name = localStorage.getItem('name')
        return (
            <div className="user-profile d-flex flex-row align-items-center">
                
                <div onClick={this.handleClickImage} style={{cursor: 'pointer'}}>
                    <Avatar
                        alt='...'
                        src='assets/images/logo.png'
                        //src='assets/images/logo/armytrack.png'
                        className="user-avatar"
                        
                    />
                </div>
               

                {/* <div onClick={this.handleClickImage} style={{cursor: 'pointer'}}>
                    <img src="assets/images/logo/sistelindo.png" height="40px" width="40px"/>
                </div> */}

                <div className="user-detail">
                    <h4 className="user-name" onClick={this.handleClick}>{name} <i
                        className="zmdi zmdi-caret-down zmdi-hc-fw align-middle"/>
                    </h4>
                </div>
                <Menu className="user-info"
                      id="simple-menu"
                      anchorEl={this.state.anchorEl}
                      open={this.state.open}
                      onClose={this.handleRequestClose}
                      PaperProps={{
                          style: {
                              width: 120,
                              paddingTop: 0,
                              paddingBottom: 0
                          }
                      }}
                >
                    <MenuItem onClick={() => this.handleRequestClose('profile')}>
                        <i className="zmdi zmdi-account zmdi-hc-fw mr-2"/>
                        <IntlMessages id="popup.profile"/>
                    </MenuItem>
                    <MenuItem onClick={() => this.handleRequestClose('setting')}>
                        <i className="zmdi zmdi-settings zmdi-hc-fw mr-2"/>
                        <IntlMessages id="popup.setting"/>
                    </MenuItem>
                    <MenuItem onClick={this.handleLogout}>
                        <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2"/>

                        <IntlMessages id="popup.logout"/>
                    </MenuItem>
                </Menu>
            </div>
        );
    }
}

const mapStateToProps = ({settings}) => {
    const {locale} = settings;
    return {locale}
};
export default connect(mapStateToProps, {userSignOut})(UserInfo);





// WEBPACK FOOTER //
// ./components/UserInfo/index.js